// Mock API for RBAC (Role-Based Access Control)
// To be replaced with actual backend calls
export const api = {
    rbac: {
        permissions: {
            list: async () => ({ data: [] as any[] }),
        },
        roles: {
            list: async () => ({ data: [] as any[] }),
            get: async (_id: number) => ({ data: { name: "", description: "", permissions: [] as number[] } }),
            create: async (payload: any) => ({ data: payload }),
            update: async (_id: number, payload: any) => ({ data: payload }),
            delete: async (_id: number) => ({ data: { success: true } }),
        },
        staff: {
            list: async () => ({ data: [] as any[] }),
            toggleStatus: async (_id: number) => ({ data: { success: true } }),
            assignRole: async (_id: number, _roleId: number) => ({ data: { success: true } }),
            update_direct_permissions: async (_id: number, _payload: any) => ({ data: { success: true } }),
            update_data_filters: async (_id: number, _payload: any) => ({ data: { success: true } }),
        },
        activityLogs: {
            list: async () => ({ data: [] as any[] }),
        },
    },
};
